import { pauseForSpecs } from '~/javascripts/utils/testing';

export default () => ({
  form: null,
  widgetId: null,
  submitting: false,
  recaptchaError: null,
  recaptchaLoaded: false,
  init: function () {
    this.form = this.$el.closest('form');

    if (window.grecaptcha) {
      this.createWidget();
    }

    this.form.addEventListener('htmx:afterRequest', (event) => {
      if (event.detail.xhr.status == 418) {
        this.loadRecaptchaAndExecute();
      } else if (event.detail.xhr.status == 422) {
        this.recaptchaError =
          'Sorry, Something went wrong. Please reload the page and try again.';

        pauseForSpecs(() => {
          this.submitting = false;
        });
      }
    });
  },
  submit: function () {
    if (!$(this.form).parsley().validate()) {
      return false;
    }

    this.submitting = true;
    window.htmx.trigger(this.form, 'submit');
  },
  loadRecaptchaAndExecute: async function () {
    if (this.recaptchaLoaded) {
      grecaptcha.reset(this.widgetId);
      grecaptcha.execute(this.widgetId);
      return;
    }

    if (window.grecaptcha === undefined) {
      const script = document.createElement('script');

      script.src = 'https://www.google.com/recaptcha/api.js?render=explicit';
      script.async = true;
      script.defer = true;
      script.onload = async () => {
        await this.createWidget();
        grecaptcha.execute(this.widgetId);
      };
      document.body.appendChild(script);
    } else {
      await this.createWidget();
      grecaptcha.execute(this.widgetId);
    }
  },
  createWidget: function () {
    return new Promise((resolve) => {
      const container = document.createElement('div');

      grecaptcha.ready(() => {
        this.widgetId = grecaptcha.render(container, {
          sitekey: recaptchaV2SiteKey,
          size: 'invisible',
          badge: 'inline',
          callback: (token) => this.onCaptchaSuccess(token),
        });

        this.form.appendChild(container);
        this.recaptchaLoaded = true;
        resolve();
      });
    });
  },
  onCaptchaSuccess: function (token) {
    this.form.setAttribute(
      'hx-vals',
      JSON.stringify({ 'recaptcha[token]': token })
    );

    window.htmx.trigger(this.form, 'submit');
  },
});
